import React, { useState, useRef, useEffect } from "react";
import { Globe, Check, ChevronDown } from "lucide-react";
import { useTranslation } from "react-i18next";
import { SUPPORTED, LANG_LABELS, LANG_NAMES } from "../i18n";

export default function LanguageSelector({ variant = "desktop" }) {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = SUPPORTED.includes(i18n.language) ? i18n.language : "fr";

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const choose = (lng) => { try { localStorage.setItem("om_lang_manual", "1"); } catch (_) {} i18n.changeLanguage(lng); setOpen(false); };

  if (variant === "mobile") {
    return (
      <div className="flex flex-wrap gap-2 pt-1" data-testid="lang-selector-mobile">
        {SUPPORTED.map((l) => (
          <button key={l} onClick={() => choose(l)} data-testid={`lang-opt-${l}`}
            className={`text-xs uppercase tracking-wider px-3 py-1.5 rounded-[5px] border transition-colors ${current === l ? "bg-[#C19A6B] text-white border-[#C19A6B]" : "border-white/20 text-white hover:border-[#C19A6B]"}`}>
            {LANG_LABELS[l]}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="relative" ref={ref} data-testid="lang-selector">
      <button onClick={() => setOpen((o) => !o)} data-testid="lang-selector-btn"
        className="flex items-center gap-1.5 text-[11px] uppercase tracking-[0.12em] text-white hover:text-[#C19A6B] transition-colors">
        <Globe className="w-4 h-4" /> {LANG_LABELS[current]}
        <ChevronDown className={`w-3 h-3 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 w-44 bg-[#0d0d10] border border-white/15 rounded-[8px] shadow-xl overflow-hidden z-[80]" data-testid="lang-menu">
          {SUPPORTED.map((l) => (
            <button key={l} onClick={() => choose(l)} data-testid={`lang-opt-${l}`}
              className={`w-full flex items-center justify-between px-3.5 py-2.5 text-sm text-left transition-colors ${current === l ? "text-[#C19A6B] bg-white/[0.04]" : "text-white hover:bg-white/[0.06]"}`}>
              <span>{LANG_NAMES[l]}</span>
              {current === l && <Check className="w-3.5 h-3.5" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
